import { render, staticRenderFns } from "./ServiceAbility.vue?vue&type=template&id=24f319f2&"
import script from "./ServiceAbility.vue?vue&type=script&lang=js&"
export * from "./ServiceAbility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports